import React, { useCallback } from "react";
import useGetBuildSpinnerFrame from "../../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { BnbLabel } from "../../../../utils/labels";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useBnbSelector } from "../../../../redux/store";
import { generateImageSet } from "../../../../utils/typedUtils";
import PaymentDetails from "../../common/PaymentDetails";
import * as Styles from "./styles/Buy";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import useStepUrl from "../../../../hooks/shared/actions/useStepUrl";

type PropsType = {
    buyCar: () => void;
};

const PaymentPanel = (props: PropsType): JSX.Element => {
    const { buyCar } = props;
    const car = useBnbSelector((state) => state.car);
    const { colour } = useBnbSelector((state) => state.basket);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    const summaryStep = useStepUrl(NavStep.Summary, undefined, true);

    const { getImage, cacheKey } = useGetBuildSpinnerFrame(false);
    const getFrame = useCallback(() => {
        return generateImageSet(
            (width: number, height: number) => getImage(width, height, 2, { bgColour: "", padding: 0 }),
            800,
            460,
        ); // same size as mobile basket
    }, [cacheKey]);

    return (
        <>
            <Styles.Panel>
                <Styles.ImageWrapper>
                    <ImageFluid
                        src={getFrame().src}
                        srcSet={getFrame().srcset}
                        sizes=""
                        draggable={false}
                        alt={`${car.model.name} ${car.grade.name} ${colour.name}`}
                    />
                </Styles.ImageWrapper>
                <Styles.BasketTitle>
                    {car.model.webtitleSectionName}
                    <span>{car.grade.webtitleSectionName}</span>
                </Styles.BasketTitle>
                <Type.Text as="div" mb={1}>
                    {car.body.webtitleSectionName}
                </Type.Text>
                <Styles.Details>
                    <div>{car.motorization.engine.name}</div>
                    <div>
                        {car.motorization.transmission.name} ({car.motorization.wheeldrive.name})
                    </div>
                </Styles.Details>
                <PaymentDetails />
                <Button.Primary onClick={buyCar} mx={0} mt={3} width={1}>
                    <Text.Button>
                        <BnbLabel
                            label={financeOption === "cash" ? "buyBuyNow" : "buyBuyNowMonthly"}
                            fallbackLabel="buyBuyNow"
                        />
                    </Text.Button>
                </Button.Primary>
            </Styles.Panel>
            <Button.Link hasIcon large mt={5} as="a" href={summaryStep.href} data-testid="back-to-summary">
                <IconWrapper>
                    <Icon variant="arrowLeft" />
                </IconWrapper>
                <Text.Button>
                    <BnbLabel label="buyBackToSummary" />
                </Text.Button>
            </Button.Link>
        </>
    );
};

export default PaymentPanel;
